var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M5.34 6.67h9.32a.83.83 0 01.58 1.42l-4.65 4.65a.83.83 0 01-1.18 0L4.76 8.1a.83.83 0 01.58-1.42z","fill":"#FEFEFE"}})])}
var staticRenderFns = []

export { render, staticRenderFns }